import styled from "styled-components";

export const GraphCointaner = styled.div`
  width: 115px;
  height: 70px;
`;